import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { Merchant } from '../../features/merchants/types';

interface TenantState {
  activeMerchant: Merchant | null;
  isSelectorOpen: boolean;
  setActiveMerchant: (merchant: Merchant | null) => void;
  openSelector: () => void;
  closeSelector: () => void;
  clearTenant: () => void;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      activeMerchant: null,
      isSelectorOpen: false,

      setActiveMerchant: (merchant) =>
        set({ activeMerchant: merchant, isSelectorOpen: false }),

      openSelector: () => set({ isSelectorOpen: true }),
      closeSelector: () => set({ isSelectorOpen: false }),

      clearTenant: () =>
        set({ activeMerchant: null, isSelectorOpen: false }),
    }),
    {
      name: 'tenant-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ activeMerchant: state.activeMerchant }),
    }
  )
);
